<template>
  <div class="level-card">
    <div
      class="card"
      :class="['level' + level, { 'not-unlock': currentLevel < level }]"
      @click="$emit('selectLevel', level)"
    >
      <div class="icon" v-if="currentLevel < level"></div>
      <div class="text" v-if="currentLevel < level">{{$vi18n('$i18n# 未解锁 #i18n$')}}</div>
    </div>
    <div class="btn" @click="$emit('selectLevel', level)">{{ name }}</div>
    <div class="dot" @click="$emit('selectLevel', level)"></div>
    <div class="score">{{ score }}</div>
  </div>
</template>

<script>
export default {
  name: 'level-card',
  props: {
    score: {
      type: Number,
      default: 0,
    },
    level: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    currentLevel: {
      type: Number,
      default: 0,
    }
  },
};
</script>

<style lang="scss" scoped>
.level-card {
  position: relative;
  color: #fff;
  .card {
    width: 106px;
    height: 116px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .icon {
      background-image: url("../../../assets/images/icon_Notunlocked(1).png");
      width: 16px;
      height: 22px;
      background-size: 100% 100%;
    }
    .text{
      text-align: center;
    }
    &.level1 {
      background-image: url("../../../assets/images/icon_Stardust.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_Stardust_no.png");
      }
    }
    &.level2 {
      background-image: url("../../../assets/images/icon_nebula.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_nebula_no.png");
      }
    }
    &.level3 {
      background-image: url("../../../assets/images/icon_star.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_star_no.png");
      }
    }
    &.level4 {
      background-image: url("../../../assets/images/icon_Redgiant.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_Redgiant_no.png");
      }
    }
    &.level5 {
      background-image: url("../../../assets/images/icon_superstar.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_superstar_no.png");
      }
    }
    &.level6 {
      background-image: url("../../../assets/images/icon_supernava.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_supernava_no.png");
      }
    }
    &.level7 {
      background-image: url("../../../assets/images/icon_Blackhole.png");
      &.not-unlock {
        background-image: url("../../../assets/images/icon_Blackhole_no.png");
      }
    }
  }
  .btn {
    width: 76px;
    height: 38px;
    line-height: 1;
    // line-height: 38px;
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-image: url("../../../assets/images/btn_stardust.png");
    background-size: 100% 100%;
    position: absolute;
    left: 15px;
    bottom: -8px;
    cursor: pointer;
    font-size: 14px;
    font-family: FZCuYuan-M03S;
    color: #ffffff;
  }
  .dot {
    box-sizing: border-box;
    width: 76px;
    height: 76px;
    background-image: url("../../../assets/images/icon_point1.png");
    background-size: 100% 100%;
    position: absolute;
    left: 15px;
    bottom: -66px;
    cursor: pointer;
  }
  .score {
    width: 106px;
    text-align: center;
    position: absolute;
    bottom: -100px;
    color: #bbb;
  }
}
</style>
